module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_0_1.2b0607b5.png";